/**
 * @file supplementRoot.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 08, 2025 16:28
 */
import { all, fork } from 'redux-saga/effects';

import supplementEdit from './supplementEdit.saga';
import supplementUpdate from './supplementUpdate.saga';
import supplementView from './supplementView.saga';

export default function* rootSaga() {
    yield all([
        fork(supplementEdit),
        fork(supplementUpdate),
        fork(supplementView)
    ]);
}